import { FC } from "react";
import "styles/text-field.scss";
import cx from "classnames";
import { TextFieldProps } from "types/atoms.types";

const TextField: FC<TextFieldProps> = ({
  value,
  onChange,
  message,
  error,
  placeholder,
  inputId,
  required,
  customClass,
  preFixIcon,
  sufFixIcon,
  dropdownOption,
  handleOnSelection,
  isInputfocus,
  isMenuOpen,
  errorMessage,
  isReadOnly,
  onBlur
}) => {
  const msgClass = cx("message", { error: error });
  const labelClass = cx({
    "has-value": value,
    error: error,
    "has-prefix": preFixIcon && inputId === "search",
    "has-suffix": sufFixIcon && inputId === "radius",
  });
  const inputClass = cx(customClass, {
    error: error,
    "has-prefix": preFixIcon && inputId === "search",
    "has-suffix": sufFixIcon && inputId === "radius",
  });
  const arrowClass = cx({ "is-menu-open": isMenuOpen });
  const hasOption = cx({
    "asr-dropdown": dropdownOption && dropdownOption.length,
  });
  return (
    <span className="asr-text-field">
      <span className={`asr-text-field__input-wrapper ${inputId}-field`}>
        {preFixIcon && (
          <img
            className={`prefix-icon ${arrowClass}`}
            src={preFixIcon}
            alt=""
            role="presentation"
          />
        )}
        {sufFixIcon && (
          <img
            className={`suffix-icon ${arrowClass}`}
            src={sufFixIcon}
            alt=""
            role="presentation"
            onClick={() => isInputfocus && isInputfocus(inputId)}
          />
        )}
        <input
          name={inputId}
          readOnly={isReadOnly}
          className={inputClass}
          id={inputId}
          value={value}
          required={required}
          aria-required={required}
          onChange={onChange}
          onClick={() => isInputfocus && isInputfocus(inputId)}
          onBlur={onBlur}
          autoComplete="off"
        />
        <label className={labelClass} htmlFor={inputId}>
          {placeholder}
          {required && "*"}
        </label>
        {isMenuOpen && dropdownOption && (
          <div className={`${hasOption} ${inputId} `}>
            {dropdownOption.map((name: any, i: number) => (
              <div
                key={i}
                className={`item ${
                  typeof name === "number" &&
                  "selected-item"
                }`}
                onClick={() =>
                  handleOnSelection && handleOnSelection(name, inputId)
                }
              >
                {typeof name === "string" ? name : name?.suggestion}
              </div>
            ))}
          </div>
        )}
      </span>
      {message && <span className={msgClass}>{message}</span>}
      {errorMessage && <span className="asr-error">{errorMessage}</span>}
    </span>
  );
};

export default TextField;
